import { Avatar } from '../primitives/avatar.js'
import type { AvatarProps } from '../primitives/avatar.js'
import type { EntityType } from '@tunasong/schemas'
import { useElementTypeMedia } from '@tunasong/plugin-lib'
import type { FC } from 'react'
import { getColorCSS } from '../color/color.js'

type AvatarSize = 'small' | 'large' | 'tiny' | 'medium'

const avatarSizePx: Record<AvatarSize, number> = {
  tiny: 24,
  small: 32,
  medium: 32,
  large: 40,
}

export interface EntityAvatarProps extends Omit<AvatarProps, 'size'> {
  className?: string
  type: EntityType
  size?: AvatarSize
}

export const EntityAvatar: FC<EntityAvatarProps> = ({ className, type, size = 'large', style, ...rest }) => {
  const { icon: Icon, materialColor } = useElementTypeMedia(type)
  const px = avatarSizePx[size]

  return (
    <Avatar
      className={className}
      aria-label="entity"
      style={{
        height: px,
        width: px,
        ...(materialColor && { backgroundColor: getColorCSS(materialColor) }),
        ...style,
      }}
      {...rest}
    >
      <Icon />
    </Avatar>
  )
}

export default EntityAvatar
